import React from 'react';
import Link from 'next/link';
import config from '../lib/config';

import { BsFacebook, BsTwitter, BsWhatsapp } from 'react-icons/bs';
import { AiOutlineMail } from 'react-icons/ai';
import { Label } from './text';
import { IPostDirect } from '../models/post';

interface IProps {
	post: IPostDirect;
}

export default function SocialIconShare({ post }: IProps) {
	const pageUrl = `${config.siteUrl}/nieuws/${post.slug}`;

	return (
		<div className="py-12">
			<div className="flex flex-row items-center justify-center my-6">
				<Label className="mr-4">Deel via: </Label>
				<ul
					role="list"
					className="flex justify-center items-center gap-6"
				>
					<li className="col-span-1">
						<Link
							target="_blank"
							href={`https://www.facebook.com/sharer/sharer.php?u=${pageUrl}&t=${post.title}`}
						>
							<BsFacebook className="w-8 h-8 hover:cursor-pointer hover:fill-black-200 transition-all duration-200" />
						</Link>
					</li>
					<li className="col-span-1">
						<Link
							target="_blank"
							href={`https://twitter.com/intent/tweet?source=${pageUrl}&text=${post.title}: ${pageUrl}`}
						>
							<BsTwitter className="w-8 h-8 hover:cursor-pointer hover:fill-black-200 transition-all duration-200" />
						</Link>
					</li>
					<li className="col-span-1 block sm:hidden">
						<Link
							target="_blank"
							href={`whatsapp://send?text=${post.title}: ${pageUrl}`}
						>
							<BsWhatsapp className="w-8 h-8 hover:cursor-pointer hover:fill-black-200 transition-all duration-200" />
						</Link>
					</li>
					<li className="col-span-1">
						<Link
							target="_blank"
							href={`mailto:?subject=${post.title}&body=Check dit artikel op ${config.siteName}: ${pageUrl}.`}
						>
							<AiOutlineMail className="w-9 h-9 hover:cursor-pointer hover:fill-black-200 transition-all duration-200" />
						</Link>
					</li>
				</ul>
			</div>
		</div>
	);
}
